import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { BudgetCategory } from '@webapp/platform/budgets'
import { expenseReportQueryConfig } from '../../../query-configs/expenseReport'

export const useQueryBudgetCategoriesForExpense = ({
  expenseUuid,
  expenseId,
  enabled = true,
}: {
  expenseUuid: uuid
  expenseId: number | undefined
  enabled?: boolean
}) => {
  const { data, isLoading, isError } = useQuery({
    ...expenseReportQueryConfig.getBudgetCategories({
      expenseUuid,
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
      expenseId: expenseId as number, // Casting to number because expenseId is defined (enforced via enabled check)
    }),
    enabled: !!expenseId && enabled,
  })

  const { budgetCategories, uncategorizedSpend } = useMemo(() => {
    if (!data)
      return { budgetCategories: undefined, uncategorizedSpend: undefined }
    return {
      budgetCategories: data.data.map(
        (category) => new BudgetCategory(category)
      ),
      uncategorizedSpend: data.metadata.uncategorizedSpend,
    }
  }, [data])

  return {
    budgetCategories,
    uncategorizedSpend,
    isLoading,
    isError,
  }
}
